export { useDeviceOrientation } from '@react-native-community/hooks';
